<template>
	<div class="bg-grey-50 dark:bg-gray-900 min-h-screen">

        <!-- Hero -->
        <div
            class="w-full bg-contain bg-center h-96 text-center flex items-center justify-center relative"
        >
            <div class="w-full max-w-7xl h-full bg-contain bg-center z-20 inset-0" :style="`background-image: url(https://cfl-mango.s3.amazonaws.com/uploads/about/posting-on-x-banner.jpg)`" />
            <div class="absolute w-full h-full bg-cover bg-center z-10 inset-0" :style="`background-image: url(https://cfl-mango.s3.amazonaws.com/uploads/about/posting-on-x-banner.jpg)`">
                <div class="absolute w-full h-full backdrop-blur-xl inset-0" />
            </div>
        </div>

		<!-- If we've actually got blogs... -->
		<Mango
            v-slot="{data: blogs, loading}"
            collection="blogs"
            :query="{search: {status: 'open'}, sort: {created: -1}, limit: 25}"
            :infinite="true"
            class="w-full flex justify-center"
        >
            <!-- This is where all the blogs live -->
            <section class="w-full relative z-10 w-full max-w-7xl mx-auto">
                <div class="flex flex-col
                justify-center items-center py-4 md:py-8 px-5 md:px-10 w-full">

                    <!-- Blog width constraint -->
                    <div class="w-full max-w-6xl flex flex-col-reverse lg:flex-row flex-wrap justify-center items-start">
                        <div class="w-full lg:w-2/3 flex flex-col flex-wrap justify-center items-center">
                            <!-- X/Twitter Feed -->
                            <div class="w-full mb-8 flex flex-col items-center text-center">
                                <div class="text-grey-200 uppercase text-2xl mb-4 font-bold mx-auto">X Feed</div>
                                <div class="w-full text-lg underline">
                                    <a class="twitter-timeline" href="https://twitter.com/SBrownOnline?ref_src=twsrc%5Etfw">Tweets by SBrownOnline</a>
                                </div>
                            </div>
                            <!-- Blogs Component -->
                            <div class="text-grey-200 uppercase text-2xl mb-4 font-bold">Blogs</div>
                            <template v-for="blog, index in blogs" :key="blog.id">
                                <template v-if="!index || dayjs(blog.startDate).format('MMMM') != dayjs(blogs[index-1].startDate).format('MMMM')">
                                    <div v-if="index" class="text-grey-200 uppercase text-2xl mb-4 font-bold">
                                        {{ dayjs(blog.startDate).format('MMMM YYYY') }}
                                    </div>
                                </template>
                                <Blog :blog="blog" />
                            </template>
                        </div>
                        <div class="w-full lg:w-1/3 lg:pl-4 lg:sticky" style="top: 4.5rem;">
                            <div class="w-full flex justify-center" style="top: 4.5rem;">
                                <div class="w-full">
                                    <FamilyWorshipSidebarCta class="mb-8" />
                                    <section class="w-full flex flex-wrap justify-center">
                                        <div class="w-full flex flex-col sm:flex-row lg:flex-col mb-8 shadow sm:shadow-none bg-white dark:bg-gray-700 rounded-lg items-center">
                                            <div class="w-full sm:w-auto dark:border-gray-500 lg:w-full border-b sm:border-r sm:border-b-0 lg:border-b lg:border-r-0 border-grey-50 flex flex-col items-center justify-center p-8 text-center">
                                                <div
                                                    class="rounded-full w-24 h-24 pb-2 bg-cover bg-center bg-no-repeat"
                                                    style="background-image: url(&quot;https://cfl-mango.s3.amazonaws.com/assets/people/60ca3431e7346d3c2b733f3d/image.jpg&quot;);"
                                                ></div>
                                            </div>
                                            <div class="w-full flex-grow p-8 text-sm flex flex-col cursor-auto">
                                                <div id="" class="custom-text">
                                                    <p><strong>Scott T. Brown</strong> is the President of the&nbsp;<a href="https://churchandfamilylife.com">Church &amp; Family Life</a>&nbsp;and pastor at&nbsp;<a href="https://hopebaptistchurch.info/">Hope Baptist Church</a>&nbsp;in Wake Forest, North Carolina. Scott graduated from California State University in Fullerton with a degree in History and received a Master of Divinity degree from Talbot School of Theology. &nbsp;He gives his time to expository preaching and local pastoral ministry, as well as conferences on Biblical doctrine and church and family reformation. He and his wife Deborah have four grown children. Scott helps people think through the two greatest evangelistic and discipleship institutions God has provided — the church and the family.</p>
                                                </div>
                                            </div> <!---->
                                        </div>
                                    </section>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </section>
        </Mango>
	</div>
</template>

<script>
import dayjs from 'dayjs'
import Blog from './blog.vue'
import FamilyWorshipSidebarCta from './family-worship-sidebar-cta.vue'

export default {
	components: { Blog, FamilyWorshipSidebarCta },
	data() {
		return {

		}
	},
    mounted() {
        // twttr.widgets.load()
    },
    methods: {
        dayjs
    }
}
</script>
